





























































import { Component, Vue, Prop, InjectReactive } from 'vue-property-decorator';
import { PaycheckForm } from './PaycheckForm';
import { GQL_municipalities_currentUnit_municipalities, GQL_municipalities } from '@/queries/__generated__/municipalities';
import { SmartQuery } from 'vue-apollo-decorator';
import { ALL_MUNICIPALITIES } from '@/queries/Municipality';

@Component
export default class PaycheckUnitInfo extends Vue {
  @Prop({ type: Object, required: true }) private paycheck!: PaycheckForm;

  @SmartQuery<PaycheckUnitInfo, GQL_municipalities>({
    query: ALL_MUNICIPALITIES,
    update: data => data.currentUnit.municipalities,
  }) private municipalities!: GQL_municipalities_currentUnit_municipalities[];

  @InjectReactive() private isLocked!: boolean;
  @InjectReactive() private hasEditPermissions!: boolean;
}
